import {
  injectSlice,
  createAsyncThunk,
  createSlice,
} from '@bonanza-social/toolkit/state';
import ShopService from '../services/ShopService/ShopService';
import { SlotsState } from './slots.types';
import { ApiError, ZodError } from '@bonanza-social/toolkit/api';
import { ShopItemPurchaseResponseSchema } from '../services/ShopService/ShopService.schemas';

export const fetchShopSlots = createAsyncThunk('shopSlots/fetch', async () => {
  const response = await ShopService.getSlots();
  return response;
});

export const purchaseShopSlot = createAsyncThunk(
  'shopSlots/purchase',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await ShopService.purchaseSlot({
        pathParams: { id },
      });

      ShopItemPurchaseResponseSchema.parse(response);

      return response;
    } catch (e) {
      if (e instanceof ApiError || e instanceof ZodError) {
        return rejectWithValue(e);
      }

      throw e;
    }
  },
);

const initialState: SlotsState = {
  data: undefined,
  dataState: 'idle',
};

const slots = createSlice({
  name: 'slots',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchShopSlots.pending, (state) => {
      state.dataState =
        state.dataState === 'fulfilled' ? 'refreshing' : 'pending';
    });

    builder.addCase(fetchShopSlots.rejected, (state) => {
      state.dataState = 'rejected';
    });

    builder.addCase(fetchShopSlots.fulfilled, (state, action) => {
      state.data = action.payload;
      state.dataState = 'fulfilled';
    });
  },
});

export const withSlots = injectSlice({
  reducerPath: 'slots',
  reducer: slots.reducer,
});

export const selectSlots = withSlots.selector(
  (state) => state.slots.data?.slots || [],
);

export const selectSlotsDataState = withSlots.selector(
  (state) => state.slots.dataState,
);

export const selectSlotsSystemTimeDifference = withSlots.selector(
  (state) => state.slots.data?.systemTime,
);

declare global {
  interface LazyLoadedSlices {
    slots: ReturnType<typeof slots.reducer>;
  }
}
